var map = {
	"./assets/checkmark.svg": 81673,
	"./assets/colour-star.svg": 93119,
	"./assets/crossmark.svg": 72201,
	"./assets/dummy_user.png": 37752,
	"./assets/grey-star.svg": 10493,
	"./assets/guardian-logo.png": 40022,
	"./assets/help_icon.svg": 90834,
	"./assets/icon.gif": 9245,
	"./assets/indoor-light.png": 42612,
	"./assets/inside-border-en.png": 19002,
	"./assets/inside-border-zh.png": 92278,
	"./assets/left-arrow-icon.svg": 76037,
	"./assets/mannings_logo.png": 4791,
	"./assets/panoptic_ai.svg": 8361,
	"./assets/panoptic_ai_vitals.png": 41328,
	"./assets/silh_no_neck.png": 7205,
	"./assets/silh_with_neck.png": 43179,
	"./assets/steady-phone-en.png": 37325,
	"./assets/steady-phone-zh.png": 83626,
	"./assets/switch-camera.svg": 28540,
	"./assets/whole-face-en.png": 25417,
	"./assets/whole-face-zh.png": 61899,
	"./bounding-box-view": 91463,
	"./bounding-box-view.vue": 91463,
	"./breathing-circle": 42176,
	"./breathing-circle.vue": 42176,
	"./camera": 79364,
	"./camera.js": 79364,
	"./circular-progress": 82155,
	"./circular-progress.vue": 82155,
	"./condition-icon": 11160,
	"./condition-icon.vue": 11160,
	"./conditions-hud": 83973,
	"./conditions-hud.vue": 83973,
	"./face-detection-view": 92023,
	"./face-detection-view.vue": 92023,
	"./face-landmarks-detection": 21847,
	"./face-landmarks-detection.js": 21847,
	"./face-mesh-view": 84945,
	"./face-mesh-view.css": 64569,
	"./face-mesh-view.vue": 84945,
	"./home-page": 30577,
	"./home-page.vue": 30577,
	"./information-box": 28545,
	"./information-box.vue": 28545,
	"./loading-screen": 23039,
	"./loading-screen.vue": 23039,
	"./plans": 55755,
	"./plans.js": 55755,
	"./profile-form": 65256,
	"./profile-form.vue": 65256,
	"./scan-tutorial": 86840,
	"./scan-tutorial.vue": 86840,
	"./signal-quality-box": 28805,
	"./signal-quality-box-floating": 29796,
	"./signal-quality-box-floating.vue": 29796,
	"./signal-quality-box.vue": 28805,
	"./terms-conditions": 49828,
	"./terms-conditions.vue": 49828,
	"./user-profile-input": 71258,
	"./user-profile-input-lite": 93966,
	"./user-profile-input-lite.vue": 93966,
	"./user-profile-input.vue": 71258,
	"./video-feed": 14152,
	"./video-feed.vue": 14152,
	"./vital-sign-button": 30843,
	"./vital-sign-button-js": 1517,
	"./vital-sign-button-js.vue": 1517,
	"./vital-sign-button.vue": 30843,
	"./vital-signs/blood-pressure": 14076,
	"./vital-signs/blood-pressure.vue": 14076,
	"./vital-signs/bmi": 89447,
	"./vital-signs/bmi.vue": 89447,
	"./vital-signs/covid-risk": 16226,
	"./vital-signs/covid-risk.vue": 16226,
	"./vital-signs/cvd-risk": 66111,
	"./vital-signs/cvd-risk.vue": 66111,
	"./vital-signs/data-hud": 32110,
	"./vital-signs/data-hud.vue": 32110,
	"./vital-signs/facial-skin-age": 3398,
	"./vital-signs/facial-skin-age.vue": 3398,
	"./vital-signs/heart-rate": 78911,
	"./vital-signs/heart-rate.vue": 78911,
	"./vital-signs/hrv-ibi": 67477,
	"./vital-signs/hrv-ibi.vue": 67477,
	"./vital-signs/hrv-rmssd": 9580,
	"./vital-signs/hrv-rmssd.vue": 9580,
	"./vital-signs/hrv-sdnn": 62861,
	"./vital-signs/hrv-sdnn.vue": 62861,
	"./vital-signs/o2-saturation": 50955,
	"./vital-signs/o2-saturation.vue": 50955,
	"./vital-signs/respiratory-rate": 24342,
	"./vital-signs/respiratory-rate.vue": 24342,
	"./vital-signs/stress-rating": 30274,
	"./vital-signs/stress-rating.vue": 30274,
	"./vital-signs/temperature": 98593,
	"./vital-signs/temperature.vue": 98593,
	"./vital-signs/wellness": 31096,
	"./vital-signs/wellness.vue": 31096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90656;